export * from './shared/ngd3.model';
export * from './shared/utils/unique-id-generator';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Core components
import { SvgComponent } from './core/svg.component';
import { ClipPathComponent } from './core/clip-path.component';
import { CanvasComponent } from './core/canvas.component';

const components = [SvgComponent, ClipPathComponent, CanvasComponent];

@NgModule({
  imports: [CommonModule],
  declarations: components,
  exports: components,
})
export class NgD3Module {}
